export default __webpack_public_path__ + "static/media/Segoe-UI-Bold.21ecd693.woff";